<div class="confirm-telephone" [ngClass]="{'with-min-h' : haveMinHeight,'pad':load.flowConfirmTelephone=='pad'}">
	<div *ngIf="sesion.authenticationPhoneStep==1" class="step-telephone">
		<div class="info" [ngSwitch]="load.flowConfirmTelephone">
			<div *ngSwitchCase="'dash'">
				<h2>¡Genial! Estás muy cerca de tomar el control de tu vida financiera.</h2>
				<p>Queremos confirmar la siguiente información, nos ayudará a estar más en contacto contigo.</p>
			</div>
			<div *ngSwitchCase="'pad'">
				<h2>¡Genial! Estás muy cerca de tomar el control de tus obligaciones!</h2>
				<p>Antes de iniciar el proceso de negociación de esta obligación con nuestro aliado, confirma:</p>
			</div>
		</div>
		<form class="form-telephone" autocomplete="off" novalidate #datos="ngForm" (ngSubmit)="sendCode()">
			<div class="form-group">
				<label for="cellphone">Tu número celular</label>
				<input class="form-control" placeholder="Celular" minlength="10" maxlength="10" type="tel"
					class="form-control" id="celular" pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)" required="required"
					[(ngModel)]="sesion.validatedPhone" #celular="ngModel" name="celular"
					[ngClass]="{'is-valid': celular.valid, 'is-invalid': ( celular.errors?.['required'] && celular.touched ) }">
			</div>
			<div class="ctas">
				<button type="submit" [attr.disabled]="datos.valid && !loadSendCode ? null : 'disabled'"
					[ngClass]="{'disabled': !datos.valid && !loadSendCode }" class="btn-confirm orange"
					id="actualizarOferta">
					<span *ngIf="!loadSendCode">Continuar</span>
					<i *ngIf="!loadSendCode" class="fa fa-angle-right" aria-hidden="true"></i>
					<span class="custom-loader white-c" *ngIf="loadSendCode"></span>
				</button>
				<button *ngIf="!loadSendCode" type="button" (click)="closeConfirmTel()" class="btn-confirm purple"
					id="cancelarOferta">
					Cancelar
					<i class="fa fa-angle-right" aria-hidden="true"></i>
				</button>
			</div>
		</form>
	</div>
	<div *ngIf="sesion.authenticationPhoneStep==2" class="step-code">
		<div class="info" [ngSwitch]="load.flowConfirmTelephone">
			<h2>Validación de celular.</h2>
			<div *ngSwitchCase="'dash'">
				<p>Por favor ingresa el código de seis (6) dígitos que enviamos vía mensaje de texto al celular que
					ingresaste.
				</p>
			</div>
			<div *ngSwitchCase="'pad'">
				<p>Por favor ingresa el código de seis (6) dígitos que enviamos vía mensaje de texto al celular que
					ingresaste.
				</p>
				<p>Esto facilitará el proceso de negociación con el Aliado.</p>
			</div>
		</div>
		<form class="form-code" autocomplete="off" novalidate (ngSubmit)="validateCode()">
			<div class="form-group code-cel">
				<label for="code">Ingresa código</label>
				<input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)"
					minlength="1" maxlength="1" type="tel" class="form-control" id="code-1"
					pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)" required="required">
				<input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)"
					minlength="1" maxlength="1" type="tel" class="form-control" id="code-2"
					pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)" required="required">
				<input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)"
					minlength="1" maxlength="1" type="tel" class="form-control" id="code-3"
					pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)" required="required">
				<input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)"
					minlength="1" maxlength="1" type="tel" class="form-control" id="code-4"
					pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)" required="required">
				<input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)"
					minlength="1" maxlength="1" type="tel" class="form-control" id="code-5"
					pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)" required="required">
				<input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)"
					minlength="1" maxlength="1" type="tel" class="form-control" id="code-6"
					pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)" required="required">
				<div *ngIf="errorCode" class="error-confirm-tel">
					<p>El código ingresado es incorrecto.</p>
				</div>
				<div class="re-code">
					<p><b>{{minutes | number:'2.0'}}:{{seconds | number:'2.0' }}</b> Para poder solicitar un nuevo
						código</p>
					<button type="button" (click)="sendCode(true)" [disabled]="isSendCode">- Enviar un nuevo código
						-</button>
				</div>
			</div>
			<div class="ctas">
				<button [attr.disabled]="isValidCode() && !loadSendCode ? null : 'disabled'"
					[ngClass]="{'disabled': !isValidCode() && !loadSendCode }" type="submit" class="btn-confirm orange"
					id="actualizarOferta">
					<span *ngIf="!loadSendCode">Continuar</span>
					<i *ngIf="!loadSendCode" class="fa fa-angle-right" aria-hidden="true"></i>
					<span class="custom-loader white-c" *ngIf="loadSendCode"></span>
				</button>
				<button *ngIf="!loadSendCode" type="button" (click)="nextStep(1)" class="btn-confirm purple "
					id="cancelarOferta">
					Regresar
					<i class="fa fa-angle-right " aria-hidden="true"></i>
				</button>
			</div>
		</form>
	</div>
	<div *ngIf="sesion.authenticationPhoneStep==3" class="step-confirm">
		<div [ngSwitch]="load.flowConfirmTelephone">
			<div *ngSwitchCase="'dash'">
				<h2 *ngIf="!load.semiValidPhone" class="purple">¡Genial!</h2>
				<p *ngIf="!load.semiValidPhone">Hemos confirmado tu número de celular. Estás un paso más cerca de tomar
					el control de tu vida
					financiera.</p>
				<h2 *ngIf="load.semiValidPhone" class="purple">¡Lo sentimos!</h2>
				<p *ngIf="load.semiValidPhone">¡No fue posible validar tu número de celular! Sin embargo, puedes
					continuar viendo tu historia de crédito.</p>
				<br />
				<div class="ctas">
					<button (click)="finalStep()" class="btn-confirm orange">
						Continuar
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</button>
					<button (click)="nextStep(1)" class="btn-confirm secondary">
						Actualizar mi número de celular
					</button>
				</div>
			</div>
			<div *ngSwitchCase="'pad'" class="view-pad">
				<h3 *ngIf="!failIntention && !load.semiValidPhone">¡Genial!</h3>
				<h3 *ngIf="!failIntention && load.semiValidPhone">¡No fue posible validar tu número!</h3>
				<h3 *ngIf="failIntention">¡Ups! Algo salió mal.</h3>
				<p *ngIf="!failIntention && !load.semiValidPhone">Ahora te enviaremos a iniciar el proceso de
					negociación de
					esta obligación con
					nuestro <b>aliado</b>.</p>
				<p *ngIf="!failIntention && load.semiValidPhone">Sin embargo te enviaremos a iniciar el proceso de
					negociación de esta obligación con
					nuestro <b>aliado</b>.</p>
				<p *ngIf="!failIntention && load.semiValidPhone">Puedes intentar validar tu número en otro momento.</p>
				<p *ngIf="failIntention">No pudimos iniciar el proceso de negociación de esta obligación con nuestro
					<b>aliado</b>. Por favor, intenta nuevamente más tarde.
				</p>
				<div class="ctas">
					<button target="_blank" class="btn-confirm orange" (click)="finalStep()">
						<span *ngIf="!isLoadSaveIntention">{{(failIntention ? 'Cerrar' : 'Continuar')}}</span>
						<i *ngIf="!isLoadSaveIntention" class="fa fa-angle-right" aria-hidden="true"></i>
						<span class="custom-loader" *ngIf="isLoadSaveIntention"></span>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>